import {Routes} from '@angular/router';
import {AuthenticationGuard, AuthorizationGuard} from '@softline/auth';
import {importProvidersFrom} from '@angular/core';
import {BULK_ENTITY_SERVICE, SOFTLINE_SERVICE_HTTP, SOFTLINE_STORE_ENTITY_SERVICE, StoreModule} from '@softline/core';
import {
  SOFTLINE_FEATURE_KUNDEN_KONDITIONSLISTE,
  SOFTLINE_PERMISSION_KUNDENKONDITIONSLISTE
} from './kunde-konditionsliste.shared';
import {KundenKonditionslisteStore} from './store/kunden-konditionsliste.store';
import {KundenKonditionslisteService} from './services/kunden-konditionsliste.service';
import {kundenKonditionslisteProviders} from './kunden-konditionsliste.providers';

export const kundenKonditionslisteRoutes: Routes = [
  {
    path: 'kundenkonditionsliste',
    loadComponent: () => import('./components/kunden-konditionsliste.component').then(o => o.KundenKonditionslisteComponent),
    children: [
      {path: '', loadComponent: () => import('./components/list-products/list-products.component').then(o => o.ListProductsComponent)},
      {path: '**', redirectTo: ''}
    ],
    canActivate: [AuthenticationGuard, AuthorizationGuard],
    data: {permission: SOFTLINE_PERMISSION_KUNDENKONDITIONSLISTE},
    providers: [
      KundenKonditionslisteService,
      importProvidersFrom(
        StoreModule.forFeature({
          name: SOFTLINE_FEATURE_KUNDEN_KONDITIONSLISTE,
          feature: KundenKonditionslisteStore.feature,
          providers: [
            {
              provide: SOFTLINE_STORE_ENTITY_SERVICE,
              useFactory: (s: any) => new KundenKonditionslisteService(s),
              deps: [SOFTLINE_SERVICE_HTTP],
            },
            {
              provide: BULK_ENTITY_SERVICE,
              useFactory: (s: any) => new KundenKonditionslisteService(s),
              deps: [SOFTLINE_SERVICE_HTTP],
            },
          ],
        }),
      ),
    ]
  },
];
